export const UPDATE_ROUTER_PARAM = 'UPDATE_ROUTER_PARAM';

export const updateRouterParam = data => ({
  type: UPDATE_ROUTER_PARAM,
  payload: data
});
